// ObjFieldCrumbTrail.jsx
import React, { memo, useMemo, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import ObjectActionCreators from '../../../../actions.js';

import {
  CrumbtrailContainer,
  CrumbtrailItem,
  CrumbtrailSeparator,
} from './ObjFieldCrumbTrailCSS.js';

const ObjFieldCrumbTrail = ({
  crumbTrail, // ex: "Root>Section>Sub>Leaf"
  crumbtrailIds, // ex: "idRoot|idSection|idSub|idLeaf"
  sep = '>',
  maxChars = 18,
  separatorIcon = '►',
}) => {
  const dispatch = useDispatch();

  // Normalisation des valeurs
  const { parts, ids } = useMemo(() => {
    const trimmed = String(crumbTrail ?? '').trim();
    const cleaned = trimmed.endsWith(sep)
      ? trimmed.slice(0, -sep.length)
      : trimmed;

    const p = cleaned
      ? cleaned
          .split(sep)
          .map((s) => s.trim())
          .filter(Boolean)
      : [];

    const i = crumbtrailIds
      ? String(crumbtrailIds)
          .split('|')
          .map((s) => s.trim())
      : [];

    return { parts: p, ids: i };
  }, [crumbTrail, crumbtrailIds, sep]);

  const handleClickCrumb = (e, index) => {
    e.stopPropagation();
    const id = ids[index];
    if (id) dispatch(ObjectActionCreators.selectObject(id));
  };

  // Fallback JS si tu veux absolument couper le texte même sans CSS ellipsis
  const cut = (txt) =>
    txt?.length > maxChars ? `${txt.slice(0, maxChars)}…` : txt;

  if (!parts.length) return null;

  return (
    <CrumbtrailContainer>
      {parts.map((text, index) => (
        <Fragment key={`crumb-${index}-${text}`}>
          <CrumbtrailItem
            onClick={(e) => handleClickCrumb(e, index)}
            title={text}
            aria-label={text}
            $maxch={maxChars} // transient prop pour styled-components
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ')
                handleClickCrumb(e, index);
            }}
          >
            {cut(text)}
          </CrumbtrailItem>
          {index < parts.length - 1 && (
            <CrumbtrailSeparator aria-hidden="true">
              {separatorIcon}
            </CrumbtrailSeparator>
          )}
        </Fragment>
      ))}
    </CrumbtrailContainer>
  );
};

export default memo(ObjFieldCrumbTrail);
